import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=6971a1dc&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"
import style0 from "../../components/common/css/Eit.css?vue&type=style&index=0&id=6971a1dc&prod&scoped=true&lang=css&external"
import style1 from "../../components/common/css/Accreditation.css?vue&type=style&index=1&id=6971a1dc&prod&scoped=true&lang=css&external"
import style2 from "./Show.vue?vue&type=style&index=2&id=6971a1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6971a1dc",
  null
  
)

export default component.exports